import * as React from "react";

export const ErrorInfo = ({ location: { state } }: any) => {
  return (
    <div>
      <label>{state.text}</label>
      <pre>{state.error.type}</pre>
      <pre> {state.error.detail}</pre>
      <label>
        <div>
          <pre>{JSON.stringify(state.error.extra, null, 2)}</pre>
        </div>
      </label>
    </div>
  );
};
